import React from "react";

const MessageModal = ({ isOpen, onClose, title, message, onConfirm, showConfirmBtn }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
      <div className="bg-white w-full max-w-md rounded-xl shadow-lg p-6 relative">
        <h2 className="text-xl font-semibold mb-4">{title}</h2>
        <p className="text-gray-700 mb-6" style={{ whiteSpace: 'pre-line' }}>{message}</p>

        <div className="flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-semibold py-2 px-4 rounded"
          >
            Close
          </button>
          {showConfirmBtn && onConfirm && (
            <button
              onClick={() => {
                onConfirm();
                onClose();
              }}
              className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded"
            >
              Confirm
            </button>
          )}
        </div>

        <button
          onClick={onClose}
          className="absolute top-3 right-4 text-gray-500 hover:text-gray-800 text-lg font-bold"
        >
          &times;
        </button>
      </div>
    </div>
  );
};

export default MessageModal;
